export default "__VITE_ASSET__BB5F$Es$__"